var _a;
import React from "react";
import { IconRaiting1, IconRaiting10, IconRaiting2, IconRaiting3, IconRaiting4, IconRaiting5, IconRaiting6, IconRaiting7, IconRaiting8, IconRaiting9, IconRaitingNA } from "./icons";
import GSLogo from "./images/gs-logo.png";
import { Container, Distance, Grades, GSAttribution, Header, Raiting, School, Table, Title } from "./styled/listing-schools";
function ListingSchools(_a) {
    var _b = _a.schools, schools = _b === void 0 ? [] : _b;
    if (!schools.length)
        return null;
    return (React.createElement(Container, null,
        React.createElement(Header, null, "Schools"),
        React.createElement(Table, null,
            React.createElement("thead", null,
                React.createElement("tr", null,
                    React.createElement("th", null, "GreatSchools Ratings"),
                    React.createElement("th", null, "Grades"),
                    React.createElement("th", { align: "left" }, "School Name"),
                    React.createElement("th", null, "Distance"))),
            React.createElement("tbody", null, schools.map(function (_a, index) {
                var title = _a.title, grades = _a.grades, distance = _a.distance, address = _a.address, raiting = _a.raiting, profilePage = _a.profilePage;
                return (React.createElement(School, { key: index },
                    React.createElement(Raiting, null, GreatSchoolRaiting[raiting || "NA"]),
                    React.createElement(Grades, null, grades),
                    React.createElement(Title, null,
                        React.createElement("a", { rel: "canonical", target: "_blank", href: "" + profilePage }, title),
                        React.createElement("p", null, address)),
                    React.createElement(Distance, null, distance)));
            }))),
        React.createElement(GSAttribution, null,
            React.createElement("p", null,
                "Data provided by",
                " ",
                React.createElement("a", { href: "https://www.greatschools.org", target: "_blank", rel: "nofollow" }, "GreatSchools.org"),
                " ",
                "\u00A9 2024. All rights reserved."),
            React.createElement("img", { src: GSLogo, alt: "GreatSchools Logo" }))));
}
export default ListingSchools;
var GreatSchoolRaiting = (_a = {},
    _a["1"] = React.createElement(IconRaiting1, null),
    _a["2"] = React.createElement(IconRaiting2, null),
    _a["3"] = React.createElement(IconRaiting3, null),
    _a["4"] = React.createElement(IconRaiting4, null),
    _a["5"] = React.createElement(IconRaiting5, null),
    _a["6"] = React.createElement(IconRaiting6, { id: "scale" }),
    _a["7"] = React.createElement(IconRaiting7, { id: "scale" }),
    _a["8"] = React.createElement(IconRaiting8, { id: "scale" }),
    _a["9"] = React.createElement(IconRaiting9, { id: "scale" }),
    _a["10"] = React.createElement(IconRaiting10, { id: "scale" }),
    _a["NA"] = React.createElement(IconRaitingNA, null),
    _a);
